import React from "react";
import NotFoundPage from "../../../pages/NotFoundPage";

const AccessGuard = ({ isAuthenticated, user, newPlan, children }) => {
  if (!isAuthenticated || !user || user.role !== "seller") {
    return (
      <NotFoundPage message="You must be logged in as a seller to access this page." />
    );
  }

  if (!newPlan) {
    return <NotFoundPage message="No plan was selected for upgrade." />;
  }

  return children;
};

export default AccessGuard;
